import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import ScrollReveal from '../components/ScrollReveal';
import './ProductPage.css';

const EnergiaPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <ScrollToTop />

      <div className="product-page">
        <section className="product-hero">
          <div className="container">
            <div className="hero-grid">
              <ScrollReveal animation="fade-right">
                <div className="hero-text">
                  <h1>Energia Inteligente</h1>
                  <p className="hero-description">
                    Otimize o consumo de energia nas suas explorações agrícolas com monitorização em tempo real,
                    análise preditiva e recomendações automáticas. Reduza custos e aumente a sustentabilidade.
                  </p>
                  <div className="hero-buttons">
                    <a href="/#contact" className="cta-btn primary">
                      Pedir Demonstração
                    </a>
                    <a href="tel:+351969059898" className="cta-btn secondary">
                      Contactar Agora
                    </a>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-left" delay={0.2}>
                <div className="hero-image">
                  <img src="/energia.png" alt="Sistema de Energia Inteligente" loading="lazy" />
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>

        <section className="product-features">
          <div className="container">
            <ScrollReveal animation="fade-up">
              <h2>Funcionalidades Principais</h2>
            </ScrollReveal>

            <div className="features-grid">
              <ScrollReveal animation="fade-up" delay={0.1}>
                <div className="feature-card">
                  <div className="feature-icon">⚡</div>
                  <h3>Monitorização em Tempo Real</h3>
                  <p>Acompanhe o consumo energético de todos os equipamentos em tempo real.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.2}>
                <div className="feature-card">
                  <div className="feature-icon">🤖</div>
                  <h3>IA Preditiva</h3>
                  <p>Algoritmos de machine learning preveem padrões e sugerem otimizações.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.3}>
                <div className="feature-card">
                  <div className="feature-icon">💡</div>
                  <h3>Recomendações Automáticas</h3>
                  <p>Receba sugestões personalizadas para reduzir o consumo energético.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.4}>
                <div className="feature-card">
                  <div className="feature-icon">📊</div>
                  <h3>Dashboards Intuitivos</h3>
                  <p>Visualize dados complexos de forma simples e compreensível.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.5}>
                <div className="feature-card">
                  <div className="feature-icon">🔌</div>
                  <h3>Deteção de Anomalias</h3>
                  <p>Identifique automaticamente equipamentos com consumos anormais.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.6}>
                <div className="feature-card">
                  <div className="feature-icon">🌱</div>
                  <h3>Integração Solar</h3>
                  <p>Maximize o aproveitamento de energia solar e renováveis.</p>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>

        <section className="product-benefits">
          <div className="container">
            <ScrollReveal animation="fade-up">
              <h2>Benefícios para o Seu Negócio</h2>
            </ScrollReveal>

            <div className="benefits-list">
              <ScrollReveal animation="fade-right" delay={0.1}>
                <div className="benefit-item">
                  <div className="benefit-number">01</div>
                  <div className="benefit-content">
                    <h3>Redução de Custos até 35%</h3>
                    <p>Reduza significativamente a fatura energética através de otimização inteligente.</p>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-right" delay={0.2}>
                <div className="benefit-item">
                  <div className="benefit-number">02</div>
                  <div className="benefit-content">
                    <h3>ROI Rápido</h3>
                    <p>Retorno do investimento em 12-18 meses através de poupanças consistentes.</p>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-right" delay={0.3}>
                <div className="benefit-item">
                  <div className="benefit-number">03</div>
                  <div className="benefit-content">
                    <h3>Manutenção Preditiva</h3>
                    <p>Previna falhas de equipamentos e reduza custos de manutenção não planeada.</p>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-right" delay={0.4}>
                <div className="benefit-item">
                  <div className="benefit-number">04</div>
                  <div className="benefit-content">
                    <h3>Pegada de Carbono Reduzida</h3>
                    <p>Contribua para um futuro mais sustentável reduzindo emissões de CO₂.</p>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>

        <section className="product-cta-section">
          <div className="container">
            <ScrollReveal animation="zoom-in">
              <div className="cta-card">
                <h2>Comece a Poupar Energia Hoje</h2>
                <p>
                  Descubra quanto pode economizar com o sistema de Energia Inteligente da Vulpes.
                  Análise gratuita do seu consumo energético.
                </p>
                <div className="cta-buttons">
                  <a href="/#contact" className="cta-btn primary large">
                    Solicitar Análise Gratuita
                  </a>
                  <Link to="/" className="cta-btn secondary large">
                    Voltar ao Início
                  </Link>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default EnergiaPage;
